import { Reducer } from 'react';
import { Band } from '../../bravoTypes';
import { BandAction } from '../actions/band';

export type BandState = {
    band?:Band;
};

const bandReducer:Reducer<BandState, BandAction> = (state = {}, action) => {
    switch(action.type){
        case "band.set":
            return {
                ...state,
                band:action.payload
            };
        default:
            return state;
    }
}

export default bandReducer;